import React from 'react';
import { toast } from './Toast';

interface ShareButtonsProps {
  url: string;
  title: string;
  description?: string;
}

const ShareButtons: React.FC<ShareButtonsProps> = ({ url, title, description = '' }) => {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  const encodedDesc = encodeURIComponent(description);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast({ title: '링크가 복사되었습니다.', variant: 'success' });
    } catch {
      // Fallback
      const input = document.createElement('input');
      input.value = url;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      toast({ title: '링크가 복사되었습니다.', variant: 'success' });
    }
  };

  const shareLinks = [
    {
      name: 'Twitter',
      icon: '𝕏',
      url: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
      bg: 'bg-black hover:bg-gray-800',
    },
    {
      name: 'Facebook',
      icon: 'f',
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      bg: 'bg-blue-600 hover:bg-blue-700',
    },
    {
      name: 'WhatsApp',
      icon: '💬',
      url: `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`,
      bg: 'bg-green-500 hover:bg-green-600',
    },
  ];

  // Suppress unused variable warning for encodedDesc when description is empty
  void encodedDesc;

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {shareLinks.map((link) => (
        <a
          key={link.name}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`inline-flex items-center justify-center w-9 h-9 rounded-full text-white text-sm font-bold transition-colors ${link.bg}`}
          title={`${link.name}에 공유`}
          aria-label={`${link.name}에 공유`}
        >
          {link.icon}
        </a>
      ))}
      <button
        onClick={handleCopyLink}
        className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-gray-200 hover:bg-gray-300 text-gray-700 text-sm transition-colors"
        title="링크 복사"
        aria-label="링크 복사"
      >
        🔗
      </button>
    </div>
  );
};

export default ShareButtons;
